namespace Nobox.Nobox {
    export interface ListCriteria {
        left?: string;
        right?: string;
    }
}
